import { MyDocumentsData } from 'cpfr-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchMyDocuments } from './MyDocumentsSlice';
import { MyDocumentsDataSelector } from './MyDocumentsDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useMyDocuments(): AbstractDataState<MyDocumentsData[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyDocuments, MyDocumentsDataSelector);
}
